import React, { Component } from "react";
import API from "../api";

const items = [
  {
    id: "1",
    process: "I. Upravljanje organizacijskom klimom i kulturom",
    kpi: "Rezultati ispitivanja organizacijske kulture",
    inputType: null,
  },
  {
    id: "2",
    process: "I. Upravljanje organizacijskom klimom i kulturom",
    kpi: "Usklađenost vrijednosti zaposlenika i organizacije",
    inputType: "postotak",
    questionNumber: "3.1.15",
  },
  {
    id: "3",
    process: "I. Upravljanje organizacijskom klimom i kulturom",
    kpi: "Prosječan indeks zadovoljstva",
    inputType: "postotak",
    questionNumber: "3.5.6",
  },
  {
    id: "4",
    process: "I. Upravljanje organizacijskom klimom i kulturom",
    kpi: "Prosječan indeks angažiranosti",
    inputType: "postotak",
    questionNumber: "3.5.8",
  },
  {
    id: "5",
    process: "I. Upravljanje organizacijskom klimom i kulturom",
    kpi: "eNPS (Employee Net Promoter Score)",
    inputType: "cijeli broj",
    questionNumber: "3.5.19",
  },
  {
    id: "6",
    process: "I. Upravljanje organizacijskom klimom i kulturom",
    kpi: "Stopa fluktuacije neželjene fluktuacije zaposlenika",
    inputType: "postotak",
    questionNumber: "7.2.12.II",
  },
  {
    id: "7",
    process: "II. Employer branding",
    kpi: "Glassdoor rating (ili slične platforme)",
    inputType: "decimalni broj",
  },
  {
    id: "8",
    process: "II. Employer branding",
    kpi: "Conversion rate - karijerna stranica",
    inputType: "postotak",
  },
  {
    id: "9",
    process: "II. Employer branding",
    kpi: "Offer acceptance rate",
    inputType: "postotak",
  },
  {
    id: "10",
    process: "II. Employer branding",
    kpi: "Early turnover rate (unutar 6 mjeseci)",
    inputType: "postotak",
  },
  {
    id: "11",
    process: "II. Employer branding",
    kpi: "Mjesečni rast followera / likeova na društvenim mrežama",
    inputType: null,
  },
  {
    id: "12",
    process: "III. Regrutiranje i selekcija",
    kpi: "Time to fill",
    inputType: "cijeli broj",
    questionNumber: "1.4.8",
  },
  {
    id: "13",
    process: "III. Regrutiranje i selekcija",
    kpi: "Quality of hire (nakon 6–12 mj.)",
    inputType: "postotak",
    questionNumber: "1.3.11",
  },
  {
    id: "14",
    process: "III. Regrutiranje i selekcija",
    kpi: "Candidate NPS",
    inputType: "cijeli broj",
    questionNumber: "1.5.14",
  },
  {
    id: "15",
    process: "III. Regrutiranje i selekcija",
    kpi: "Postotak odustajanja poželjnih kandidata tijekom selekcije",
    inputType: "postotak",
  },
  {
    id: "16",
    process: "III. Regrutiranje i selekcija",
    kpi: "Recruitment ROI",
    inputType: "postotak",
    questionNumber: "1.3.12",
  },
  {
    id: "17",
    process: "IV. Praćenje radne uspješnosti",
    kpi: "Postotak zaposlenika s definiranim ciljevima",
    inputType: "postotak",
  },
  {
    id: "18",
    process: "IV. Praćenje radne uspješnosti",
    kpi: "Distribucija ocjena radnog učinka",
    inputType: null,
  },
  {
    id: "19",
    process: "IV. Praćenje radne uspješnosti",
    kpi: "Postotak ostvarenih ciljeva (Goal Achievement Rate)",
    inputType: "postotak",
  },
  {
    id: "20",
    process: "V. Nagrađivanje i benefiti",
    kpi: "Zadovoljstvo dostupnim benefitima",
    inputType: "postotak",
    questionNumber: "5.2.9",
  },
  {
    id: "21",
    process: "V. Nagrađivanje i benefiti",
    kpi: "Zadovoljstvo sustavom plaća i nagrađivanja",
    inputType: "postotak",
    questionNumber: "5.1.20",
  },
  {
    id: "22",
    process: "V. Nagrađivanje i benefiti",
    kpi: "Postotak zaposlenika obuhvaćenih sustavom varijabilnih primitaka",
    inputType: "postotak",
  },
  {
    id: "23",
    process: "V. Nagrađivanje i benefiti",
    kpi: "Compa-Ratio",
    inputType: "postotak",
  },
  {
    id: "24",
    process: "VI. Usavršavanje i razvoj",
    kpi: "Sudjelovanje u edukacijama",
    inputType: "postotak",
  },
  {
    id: "25",
    process: "VI. Usavršavanje i razvoj",
    kpi: "Ulaganje u edukacije po zaposleniku",
    inputType: "EUR",
  },
  {
    id: "26",
    process: "VI. Usavršavanje i razvoj",
    kpi: "Stopa završenosti online edukacija",
    inputType: "postotak",
  },
  {
    id: "27",
    process: "VI. Usavršavanje i razvoj",
    kpi: "Training ROI = (Return of benefit – Investment cost) / Investment cost x 100",
    inputType: "postotak",
  },
  {
    id: "28",
    process: "VII. Razvoj karijere i napredovanje",
    kpi: "Stopa internog popunjavanja pozicija",
    inputType: "postotak",
    questionNumber: "4.4.12",
  },
  {
    id: "29",
    process: "VII. Razvoj karijere i napredovanje",
    kpi: "Godišnja stopa promocija (% zaposlenika koji su napredovali tijekom 1 godine)",
    inputType: "postotak",
  },
  {
    id: "30",
    process: "VIII. Upravljanje talentima i nasljeđivanjem",
    kpi: "Pokrivenost kritičnih pozicija nasljednicima",
    inputType: "postotak",
  },
  {
    id: "31",
    process: "VIII. Upravljanje talentima i nasljeđivanjem",
    kpi: "Readiness level nasljednika",
    inputType: null,
  },
  {
    id: "32",
    process: "VIII. Upravljanje talentima i nasljeđivanjem",
    kpi: "Stopa fluktuacije u talent poolu",
    inputType: "postotak",
  },
  {
    id: "33",
    process: "VIII. Upravljanje talentima i nasljeđivanjem",
    kpi: "Internal Mobility Rate Talenata",
    inputType: "postotak",
  },
  {
    id: "34",
    process: "IX. Razvoj menadžera",
    kpi: "Kvaliteta komunikacije s menadžerom",
    inputType: "postotak",
    questionNumber: "3.2.17",
  },
  {
    id: "35",
    process: "IX. Razvoj menadžera",
    kpi: "Usporedni rezultati 360 procjena",
    inputType: null,
  },
  {
    id: "36",
    process: "IX. Razvoj menadžera",
    kpi: "Angažiranost na razini tima",
    inputType: null,
  },
  {
    id: "37",
    process: "X. Interna komunikacija",
    kpi: "Indeks zadovoljstva kvalitetom organizacijske komunikacije",
    inputType: "postotak",
    questionNumber: "3.3.7",
  },
  {
    id: "38",
    process: "X. Interna komunikacija",
    kpi: "Praćenje klikova i engagement-a na internim komunikacijskim kanalima",
    inputType: null,
  },
  {
    id: "39",
    process: "XI. Kultura inovativnosti",
    kpi: "Broj prikupljenih sugestija za unaprjeđenjima",
    inputType: "cijeli broj",
    questionNumber: "4.2.3",
  },
  {
    id: "40",
    process: "XI. Kultura inovativnosti",
    kpi: "Broj implementiranih inovacija",
    inputType: "cijeli broj",
  },
  {
    id: "41",
    process: "XII. Raznolikost i inkluzija",
    kpi: "Unadjusted gender pay gap",
    inputType: "postotak",
    questionNumber: "5.5.16",
  },
  {
    id: "42",
    process: "XII. Raznolikost i inkluzija",
    kpi: "Rodna struktura zaposlenika",
    inputType: null,
  },
  {
    id: "43",
    process: "XII. Raznolikost i inkluzija",
    kpi: "Percepcija inkluzije",
    inputType: "postotak",
    questionNumber: "5.5.18",
  },
  {
    id: "44",
    process: "XIII. Dobrobit zaposlenika i work–life balance",
    kpi: "Udio zaposlenika koji koristi wellbeing programe",
    inputType: "postotak",
  },
  {
    id: "45",
    process: "XIII. Dobrobit zaposlenika i work–life balance",
    kpi: "Zadovoljstvo fleksibilnim radnim aranžmanima",
    inputType: "postotak",
    questionNumber: "5.4.12",
  },
  {
    id: "46",
    process: "XIII. Dobrobit zaposlenika i work–life balance",
    kpi: "Zadovoljstvo programima dobrobiti",
    inputType: "postotak",
    questionNumber: "5.3.15",
  },
  {
    id: "47",
    process: "XIV. Offboarding",
    kpi: "Razlozi odlazaka",
    inputType: null,
  },
  {
    id: "48",
    process: "XIV. Offboarding",
    kpi: "Stopa popunjenosti izlaznih upitnika",
    inputType: "postotak",
    questionNumber: "6.1.11",
  },
  {
    id: "49",
    process: "XIV. Offboarding",
    kpi: "Stopa provedenih izlaznih intervjua",
    inputType: "postotak",
    questionNumber: "6.1.10",
  },
];

const romanToIndex = { I: 0, II: 1, III: 2, IV: 3, V: 4 };

function parseQuestionNumber(qn) {
  const parts = qn.split(".");
  const key = parts.slice(0, 3).join(".");
  const answerIndex = parts[3] ? romanToIndex[parts[3]] || 0 : 0;
  return { key, answerIndex };
}

const linkedQuestionNumbers = [
  ...new Set(
    items
      .filter((item) => item.questionNumber)
      .map((item) => parseQuestionNumber(item.questionNumber).key),
  ),
];

function getInputProps(inputType) {
  switch (inputType) {
    case "postotak":
      return {
        type: "number",
        step: "0.01",
        min: "0",
        max: "100",
        suffix: "%",
      };
    case "cijeli broj":
      return { type: "number", step: "1", min: "0", suffix: "" };
    case "decimalni broj":
      return { type: "number", step: "0.01", min: "0", suffix: "" };
    case "EUR":
      return { type: "number", step: "0.01", min: "0", suffix: "€" };
    default:
      return { type: "number", step: "0.01", min: "0", suffix: "" };
  }
}

export default class QuestionTargets2026 extends Component {
  constructor(props) {
    super(props);

    let data = {};

    try {
      const parsed = JSON.parse(this.props.data.value);
      if (parsed && typeof parsed === "object") {
        data = parsed;
      }
    } catch (error) {}

    this.state = {
      data: data,
      linkedData: {},
    };
  }

  componentDidMount() {
    this._fetchLinkedValues();
  }

  _fetchLinkedValues = async () => {
    if (linkedQuestionNumbers.length === 0) return;

    try {
      const response = await API.post("", {
        action: "questionnaireAnswersByQuestionNumbers",
        id: this.props.questionnaireId,
        questionNumbers: linkedQuestionNumbers,
      });

      this.setState({ linkedData: response.data });
    } catch (error) {}
  };

  _getLinkedAnswer = (questionNumber) => {
    const { key, answerIndex } = parseQuestionNumber(questionNumber);
    const answers = this.state.linkedData[key];
    if (!answers || answers.length === 0) return null;
    return answers[answerIndex] || null;
  };

  _onLinkedChange = (questionNumber, value) => {
    const answer = this._getLinkedAnswer(questionNumber);
    if (!answer) return;

    const { key, answerIndex } = parseQuestionNumber(questionNumber);
    const linkedData = this.state.linkedData;
    const answers = [...linkedData[key]];
    const usesAdditional =
      answer.questionType && answer.questionType.indexOf("multi-choice") === 0;
    answers[answerIndex] = usesAdditional
      ? { ...answer, additional: value }
      : { ...answer, content: value };
    linkedData[key] = answers;
    this.setState({ linkedData });

    const name = usesAdditional
      ? `answer_additional_${answer.answerId}`
      : `answer_${answer.answerId}`;

    this.props.onChange({
      target: {
        name: name,
        value: value,
        type: "number",
        dataset: {
          id: String(answer.answerId),
          question: this.props.question,
        },
      },
    });
  };

  _onChange = (event) => {
    const { name, value, type, checked } = event.target;
    let data = this.state.data;
    data[name] = type === "checkbox" ? checked : value;

    this.setState({ data });

    this.props.onChange({
      target: {
        name: this.props.name,
        value: JSON.stringify(data),
        dataset: {
          id: this.props.id,
          question: this.props.question,
        },
      },
    });
  };

  render() {
    const { data } = this.state;

    let lastProcess = null;

    return (
      <table className="table">
        <thead>
          <tr>
            <th>HR proces</th>
            <th>Mjera / KPI</th>
            <th>Vrijednost</th>
            <th>Target</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            const showProcessLabel = item.process !== lastProcess;
            const processRowSpan = showProcessLabel
              ? items.filter((i) => i.process === item.process).length
              : 0;
            lastProcess = item.process;

            const isLinked = !!item.questionNumber;
            const linkedAnswer = isLinked
              ? this._getLinkedAnswer(item.questionNumber)
              : null;
            const isComputed = item.inputType === null;

            const currentValue = isLinked
              ? (linkedAnswer &&
                  (linkedAnswer.additional || linkedAnswer.content)) ||
                ""
              : data[`value_${item.id}`] || "";
            const targetValue = data[`target_${item.id}`] || "";

            return (
              <tr key={item.id}>
                {showProcessLabel && (
                  <td
                    rowSpan={processRowSpan}
                    style={{ verticalAlign: "top", fontWeight: "bold" }}
                  >
                    {item.process}
                  </td>
                )}
                <td>{item.kpi}</td>
                <td>
                  {isComputed ? (
                    <span style={{ color: "#999", fontStyle: "italic" }}>
                      —
                    </span>
                  ) : (
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      <input
                        type={getInputProps(item.inputType).type}
                        step={getInputProps(item.inputType).step}
                        min={getInputProps(item.inputType).min}
                        max={getInputProps(item.inputType).max}
                        value={currentValue}
                        className="input input-percentage"
                        onChange={
                          isLinked
                            ? (e) =>
                                this._onLinkedChange(
                                  item.questionNumber,
                                  e.target.value,
                                )
                            : this._onChange
                        }
                        name={isLinked ? undefined : `value_${item.id}`}
                      />
                      {getInputProps(item.inputType).suffix && (
                        <span>{getInputProps(item.inputType).suffix}</span>
                      )}
                    </div>
                  )}
                </td>
                <td>
                  {isComputed ? (
                    <span style={{ color: "#999", fontStyle: "italic" }}>
                      —
                    </span>
                  ) : (
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      <input
                        type={getInputProps(item.inputType).type}
                        step={getInputProps(item.inputType).step}
                        min={getInputProps(item.inputType).min}
                        max={getInputProps(item.inputType).max}
                        name={`target_${item.id}`}
                        value={targetValue}
                        className="input input-percentage"
                        onChange={this._onChange}
                      />
                      {getInputProps(item.inputType).suffix && (
                        <span>{getInputProps(item.inputType).suffix}</span>
                      )}
                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}
